import { render, staticRenderFns } from "./MarkingDetails.vue?vue&type=template&id=a8d99a52&scoped=true"
import script from "./MarkingDetails.vue?vue&type=script&lang=js"
export * from "./MarkingDetails.vue?vue&type=script&lang=js"
import style0 from "./MarkingDetails.vue?vue&type=style&index=0&id=a8d99a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d99a52",
  null
  
)

export default component.exports